import { getWidthPercents, getPrimaryColor } from '../../utils';

// export const Divider = (type: string) => (index: number) => `
//   <mj-column border-top="6px ${type} ${getPrimaryColor() || '#444444'}" width="${getWidthPercents(index)}" padding="3px 2px" style="margin: 8px 0;"/>
// `;

export const Divider = (type: string) => (index: number) => `
  <mj-divider border-width="6px" border-style="${type}" border-color="${getPrimaryColor() || '#444444'}" width="${getWidthPercents(index)}" padding="8px 0" style="margin: 8px 0;"/>
`;
